export const SUBMIT_EATERY = "ADD_ARTICLE";
export const SET_POSTCODE = "SET_POSTCODE";
export const SET_EATERY_POSTCODE = "SET_EATERY_POSTCODE";
export const SET_EATERY_ADDRESS = "SET_EATERY_ADDRESS";
export const SET_USER_LAT = "SET_USER_LAT";
export const SET_USER_LONG = "SET_USER_LONG";


